import { getStore, ECBDecryptByData, ECBDecryptByStr } from '@/util'
import { debounce } from 'lodash-es'
const calcAvg = debounce((times) => {
  const count = times.length
  const sum = times.reduce((pre, cur) => pre + cur, 0)
  const avg = (sum / count).toFixed(2)
  console.warn(`累计${count}次请求，解密平均用时：${avg}ms`)
}, 2000)
/**
 * 对输入字符串进行JSON格式化，并返回格式化后的字符串，如果输入不是正确的JSON格式字符串，原样返回
 * @param {string} str stringify的字符串
 * @returns JSON.parse后的数据
 */
const parseJson = (str) => {
  try {
    return JSON.parse(str)
  } catch (error) {
    return str
  }
}
/**
 *
 * @param {object} headers 请求头部
 * @returns {boolean} 是否是application/json类型
 */
const filterJsonType = (headers) => {
  const contentType = headers['content-type']
  const isJson = contentType.includes('json')
  return isJson
}
/**
 *
 * @param {string} data 加密数据
 * @param {string} iv 私钥
 * @returns 解密后的数据，并经过JSON.parse处理
 */
const wrapData = (data, iv) => {
  let deData = null
  if (iv) {
    deData = ECBDecryptByData(data, iv)
  } else {
    deData = ECBDecryptByStr(data)
  }
  const result = parseJson(deData)
  // console.log('result: ', result)
  return result
}
const times = []
/**
 * @description 解密
 * @param {*} config
 * @returns config
 */
export default (config) => {
  // 多一层try catch是在本拦截器消费错误，避免将错误暴露给顶层 axios，导致意外的错误捕获，影响正常请求
  try {
    const { data, headers } = config

    const hitHeader = headers['x-yd-enc']
    // 未加密接口
    const noEnCode = typeof hitHeader === 'undefined'
    // 非json类型接口
    const noInJson = !filterJsonType(headers)
    if (noEnCode || noInJson) {
      return config
    }
    // console.time('responseDecode')
    const start = performance.now()
    const hasAuthDecode = hitHeader === '1'
    const hasNoneAuthDecode = hitHeader === '0'

    const pk = getStore({ name: 'RANDOM_DEVICE_UNIQUE_KEY' })
    const realData = data.data
    if (hasAuthDecode && pk && realData) {
      data.data = wrapData(realData, pk)
    }
    if (hasNoneAuthDecode && realData) {
      data.data = wrapData(realData)
    }
    // console.timeEnd('responseDecode')

    const end = performance.now()

    const diff = end - start
    times.push(diff)
    calcAvg(times)
    return config
  } catch (e) {
    return config
  }
}
